import React, {useState} from 'react'
import { provider } from 'web3-core'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import Page from 'components/layout/Page2'
import Hero from './components/Hero'
import Explorer from './components/Explorer'
import { useRecentRanches } from './hooks/useRanches'

const OuterContainer = styled.div`
    padding-top: 30px;
`

const RanchExplorer = () => {
    const { account, ethereum }: { account: string; ethereum: provider } = useWallet()
    const [recentRanchPage, setRecentRanchPage] = useState(1);
    const recentRanches = useRecentRanches(recentRanchPage);

    return (
        <>
            <Hero/>
            <Page>
                <OuterContainer>
                    <Explorer ranches={recentRanches} account={account} ethereum={ethereum} setPage={setRecentRanchPage} />
                </OuterContainer>
            </Page>
        </>
    )
}

export default RanchExplorer
